import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from '../api/api.service';
import { localStorageKeys } from '../../constants/local.storage.keys';
import jwt_decode from 'jwt-decode';
import { FeatureToggle } from 'src/app/modules/shared/models/feature.toggle';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private apiService: ApiService   
  ) { }

  public static get authorized() {
    return !!localStorage.getItem(localStorageKeys.authToken);
  }

  get currentUser$(): Observable<any> {
    return of(this.getCurrentUser());
  }

  login(command: { userName: string; password: string }): Observable<string> {
    return this.apiService
      .post('auth/login', command)
      .pipe(tap((token) => {
        this.apiService.setAuthorizationHeader(token);
      }));
  }

  logout(): void {
    this.apiService.clearAuthorizationHeader();
  }

  getCurrentUser(): any {
    const token = localStorage.getItem(localStorageKeys.authToken);
    const user = jwt_decode<TokenInfo>(token);
    return user ? user : null;
  }
}

export class TokenInfo {
  public hubName: string;
  public userName: string;
  public isAdministrator: boolean;
  public role: string;
  public status: string;
  public toggle: FeatureToggle;
  public isProxying: boolean;
  public proxiedBy: string;
}
